type TokenListener = () => void

let accessToken: string | null = null
const listeners = new Set<TokenListener>()

const notify = () => listeners.forEach((listener) => listener())

/**
 * Access tokens exist only in module memory. The rotating refresh credential is
 * owned by the browser as an HttpOnly cookie and is never exposed to JavaScript.
 */
export const setAccessToken = (token: string) => {
  accessToken = token
  notify()
}

export const clearTokens = () => {
  accessToken = null
  notify()
}

export const getAccessToken = () => accessToken

export const subscribeToTokens = (listener: TokenListener) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
